import React from 'react';
import ContentLoader from 'react-content-loader';
import PanelContainer from 'components/PanelContainer';
import MediaQuery from 'react-responsive';

const AptitudeTestContentLoader = props => (
  <>
    <MediaQuery query="(min-width: 768px)">
      <PanelContainer
        styles={{
          height: '550px',
          padding: '30px',
        }}
      >
        <ContentLoader
          height={550}
          width={825}
          speed={2}
          primaryColor="#f3f3f3"
          secondaryColor="#ecebeb"
        >
          <rect x="17" y="15" rx="0" ry="0" width="401" height="33" />
          <rect x="626" y="15" rx="0" ry="0" width="184" height="33" />
          <rect x="17" y="85" rx="0" ry="0" width="795" height="33" />
          <rect x="92" y="77" rx="0" ry="0" width="0" height="0" />
          <rect x="17" y="143" rx="0" ry="0" width="146" height="18" />
          <rect x="17" y="185" rx="0" ry="0" width="197" height="18" />
          <rect x="17" y="228" rx="0" ry="0" width="120" height="18" />
          <rect x="17" y="272" rx="0" ry="0" width="169" height="18" />
          <rect x="17" y="315" rx="0" ry="0" width="147" height="18" />
          <rect x="260" y="143" rx="0" ry="0" width="57" height="18" />
          <rect x="260" y="184" rx="0" ry="0" width="57" height="18" />
          <rect x="17" y="355" rx="0" ry="0" width="129" height="18" />
          <rect x="260" y="228" rx="0" ry="0" width="57" height="18" />
          <rect x="260" y="272" rx="0" ry="0" width="57" height="18" />
          <rect x="260" y="315" rx="0" ry="0" width="57" height="18" />
          <rect x="260" y="355" rx="0" ry="0" width="57" height="18" />
          <rect x="445" y="143" rx="0" ry="0" width="146" height="18" />
          <rect x="683" y="143" rx="0" ry="0" width="57" height="18" />
          <rect x="445" y="185" rx="0" ry="0" width="120" height="18" />
          <rect x="683" y="185" rx="0" ry="0" width="57" height="18" />
          <rect x="445" y="228" rx="0" ry="0" width="165" height="18" />
          <rect x="683" y="228" rx="0" ry="0" width="57" height="18" />
          <rect x="445" y="272" rx="0" ry="0" width="122" height="18" />
          <rect x="683" y="272" rx="0" ry="0" width="57" height="18" />
          <rect x="447" y="315" rx="0" ry="0" width="144" height="18" />
          <rect x="683" y="315" rx="0" ry="0" width="57" height="18" />
          <rect x="447" y="355" rx="0" ry="0" width="115" height="18" />
          <rect x="683" y="355" rx="0" ry="0" width="57" height="18" />
          <rect x="15" y="411" rx="0" ry="0" width="795" height="13" />
          <rect x="15" y="436" rx="0" ry="0" width="748" height="13" />
          <rect x="15" y="461" rx="0" ry="0" width="778" height="13" />
        </ContentLoader>
      </PanelContainer>
    </MediaQuery>

    <MediaQuery query="(max-width: 767px)">
      <PanelContainer
        styles={{
          height: 'auto',
          maxHeight: '500px',
          padding: '15px',
        }}
      >
        <ContentLoader
          height={500}
          width={320}
          speed={2}
          primaryColor="#f3f3f3"
          secondaryColor="#ecebeb"
          style={{
            maxHeight: '500px',
          }}
          {...props}
        >
          <rect x="10" y="10" rx="0" ry="0" width="301" height="25" />
          <rect x="92" y="77" rx="0" ry="0" width="0" height="0" />
          <rect x="108" y="51" rx="0" ry="0" width="90" height="25" />
          <rect x="10" y="100" rx="0" ry="0" width="301" height="25" />
          <rect x="10" y="141" rx="0" ry="0" width="301" height="25" />
          <rect x="10" y="184" rx="0" ry="0" width="301" height="25" />
          <rect x="10" y="228" rx="0" ry="0" width="301" height="25" />
          <rect x="10" y="273" rx="0" ry="0" width="301" height="25" />
          <rect x="10" y="317" rx="0" ry="0" width="301" height="25" />
          <rect x="10" y="359" rx="0" ry="0" width="301" height="25" />
        </ContentLoader>
      </PanelContainer>
    </MediaQuery>
  </>
);

export default AptitudeTestContentLoader;
